import _implicitStylesheets from "./lightbox.css";
import _implicitScopedStylesheets from "./lightbox.scoped.css?scoped=true";
import _wdsButton from "wds/button";
import _axImage from "ax/image";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="backdrop${0}"${2}></div>`;
const $fragment2 = parseFragment`<div tabindex="0"${3}></div>`;
const $fragment3 = parseFragment`<iframe class="media video${0}"${"a0:title"}${"a0:src"} frameborder="0" allowtransparency="true" scrolling="false" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" oallowfullscreen="true" msallowfullscreen="true" allow="autoplay"${2}></iframe>`;
const $fragment4 = parseFragment`<video controls${"a0:autoplay"} width="100%" height="auto"${3}><source${"a1:src"}${3}></video>`;
const $fragment5 = parseFragment`<figcaption class="content__info${0}"${2}><h2${"a1:id"} type-style="body-2" class="title${0}"${2}>${"t2"}</h2><p${"a3:id"} style="visibility: hidden"${3}>${"t4"}</p></figcaption>`;
const stc0 = {
  "lightbox": true
};
const stc1 = {
  classMap: {
    "container": true
  },
  key: 5
};
const stc2 = {
  "back__button": true
};
const stc3 = {
  classMap: {
    "wrapper": true
  },
  key: 7
};
const stc4 = {
  "close__button": true
};
const stc5 = {
  classMap: {
    "content": true
  },
  key: 9
};
const stc6 = {
  key: 10
};
const stc7 = {
  "media": true
};
const stc8 = {
  "data-testid": "lightbox-img"
};
const stc9 = {
  "forward__button": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, b: api_bind, sp: api_static_part, st: api_static_fragment, c: api_custom_element, d: api_dynamic_text, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "role": "dialog",
      "aria-labelledby": api_scoped_id("lightbox-header-alt-text")
    },
    key: 0,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleKeyDown))
    }
  }, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.close))
    }
  }, null)]), api_static_fragment($fragment2, 4, [api_static_part(0, {
    on: {
      "focus": _m4 || ($ctx._m4 = api_bind($cmp.handleModalInteractionLoopFocus))
    }
  }, null)]), api_element("div", stc1, [$cmp.enableControls ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc2,
    props: {
      "variant": "secondary",
      "size": "medium",
      "ariaLabel": $cmp.labels.back,
      "icon": "back"
    },
    key: 6,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.showPreviousItem))
    }
  }) : null, api_element("div", stc3, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc4,
    props: {
      "variant": "secondary",
      "size": "medium",
      "icon": "close",
      "ariaLabel": $cmp.labels.close
    },
    key: 8,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.close))
    }
  }), api_element("div", stc5, [api_element("figure", stc6, [$cmp.showVideo ? !$cmp.useVideoTag ? api_static_fragment($fragment3, 12, [api_static_part(0, {
    attrs: {
      "title": $cmp.caption,
      "src": $cmp.src
    }
  }, null)]) : null : null, $cmp.showVideo ? $cmp.useVideoTag ? api_static_fragment($fragment4, 14, [api_static_part(0, {
    attrs: {
      "autoplay": $cmp.shouldAutoplay ? "" : null
    }
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.src
    }
  }, null)]) : null : null, !$cmp.showVideo ? api_custom_element("ax-image", _axImage, {
    classMap: stc7,
    attrs: stc8,
    props: {
      "imgSrc": $cmp.src,
      "alt": $cmp.altText,
      "width": "100%",
      "height": "100%"
    },
    key: 15
  }) : null, api_static_fragment($fragment5, 17, [api_static_part(1, {
    attrs: {
      "id": api_scoped_id("lightbox-header")
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.caption)), api_static_part(3, {
    attrs: {
      "id": api_scoped_id("lightbox-header-alt-text")
    }
  }, null), api_static_part(4, null, api_dynamic_text($cmp.altText))])])])]), $cmp.enableControls ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc9,
    props: {
      "variant": "secondary",
      "size": "medium",
      "ariaLabel": $cmp.labels.forward,
      "icon": "forward"
    },
    key: 18,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.showNextItem))
    }
  }) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5r0loc26jq5";
tmpl.legacyStylesheetToken = "undefined-_lightbox";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
